import { useRef } from "react";
import { useLoaderData } from "react-router-dom";
import { motion, useInView } from "framer-motion";
import useUtils from "@/hooks/useUtils";
import PostCard from "@/components/utils/PostCard/PostCard";
import { DESKTOP } from "@/utils/appConstants";
import "./styles.scss";

/* #META
 {
  "NAME": "RelatedArticles",
  "CLASSNAME": "related-posts-container",
  "URL": "http://nicasource.local/it/tailwindcss-typography"
 }
#ENDMETA */

const RelatedArticles = () => {
  const data = useLoaderData();
  const relatedPosts = data?.related_posts || [];
  const relatedCustomPosts = data?.related_custom_post || [];
  const { device } = useUtils();
  const desktop = device === DESKTOP;

  const postsToShow = (relatedCustomPosts.length > 0 ? relatedCustomPosts : relatedPosts).slice(
    0,
    3
  );

  const firstPost = postsToShow[0];
  const remainingPosts = postsToShow.slice(1);

  const relatedRef = useRef(null);
  const isInView = useInView(relatedRef, { once: true, threshold: 0.3 });

  return (
    <motion.div
      ref={relatedRef}
      className="related-posts-container container-revamp !mt-0 xl:px-0"
      initial={{ opacity: 0, x: -80 }}
      animate={isInView ? { opacity: 1, x: 0 } : {}}
      transition={{ delay: 0.4, duration: 0.4, ease: "easeInOut" }}
    >
      {postsToShow.length > 0 && (
        <div>
          <h2 className="text-2xl text-center font-bold text-white mb-11 lg:text-start lg:text-[42px]">
            Related articles
          </h2>
          {desktop ? (
            <div className="grid grid-cols-1 gap-6 md:h-[390px] md:grid-cols-2 lg:grid-cols-3">
              {postsToShow.map((post) => (
                <PostCard
                  key={post.id}
                  categories={post.categories?.map((cat) => cat.name) || ["Uncategorized"]}
                  image={{ url: post.featured_image || placeholderImage }}
                  link={{ url: post.link }}
                  title={post.title}
                  className="related-post-card"
                  isStacked={false}
                  isFeatured={false}
                />
              ))}
            </div>
          ) : (
            <div>
              {firstPost && (
                <div className="mb-6">
                  <PostCard
                    categories={firstPost.categories?.map((cat) => cat.name) || ["Uncategorized"]}
                    image={{ url: firstPost.featured_image || placeholderImage }}
                    link={{ url: firstPost.link }}
                    title={firstPost.title}
                    className="related-first-post"
                    isStacked={false}
                    isFeatured={false}
                  />
                </div>
              )}
              {remainingPosts.length > 0 && (
                <div className="grid grid-cols-1 gap-4">
                  {remainingPosts.map((post) => (
                    <PostCard
                      key={post.id}
                      categories={post.categories?.map((cat) => cat.name) || ["Uncategorized"]}
                      image={{ url: post.featured_image || placeholderImage }}
                      link={{ url: post.link }}
                      title={post.title}
                      className="related-post-card"
                      isStacked={false}
                      isFeatured={false}
                    />
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </motion.div>
  );
};

export default RelatedArticles;
